(function () {
  'use strict';

  function DriverPrivacyConfiguration() {
    return {
      templateUrl: `configuracoes/eventos/subpaginas/driver-privacy/driver-privacy.tpl.html`,
      controller: 'DriverPrivacyCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasEventos')
    .directive('driverPrivacyConfigurationEventos', DriverPrivacyConfiguration);
}());
